module.exports = __webpack_public_path__ + "media/images/new/icons/age-a07e30bc168db818563ffe43250c2425.png";